import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/fyqVHKvsaN11Ceg7HkAzBW/Una_fotografia_profesional_y_minimalista_202606101727.jpg', 'https://cdn.magicpatterns.com/uploads/8iM2YtiQnnTsHmGgkkXnAh/sostiene_solo_el_libro_sin_202606101726.jpg', 'https://cdn.magicpatterns.com/uploads/pFSLn5hXPDVw2gHafQKyZc/ponele_esta_imagen_2K_202606101708.jpg', 'https://cdn.magicpatterns.com/uploads/jiN4iE1nwfs5dncQWcQWiR/cambia_el_texto_a_espanol_202606101559.jpg', 'https://cdn.magicpatterns.com/uploads/rUU4L7NeETqR4cGcucHmhL/pone_el_texto_en_espanol_202606101459.jpg'];
export function ImageCarousel() {
  // Duplicate the list so the loop is seamless
  const track = [...images, ...images];
  return <section className="bg-cream py-6 md:py-8 overflow-hidden" data-id="element-199">
      <div className="relative w-full overflow-hidden" data-id="element-200">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-r from-cream to-transparent z-10 pointer-events-none" data-id="element-201" />
        <div className="absolute right-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-l from-cream to-transparent z-10 pointer-events-none" data-id="element-202" />

        <motion.div className="flex gap-4 md:gap-5 w-max" animate={{
        x: ['0%', '-50%']
      }} transition={{
        ease: 'linear',
        duration: 28,
        repeat: Infinity
      }} data-id="element-203">
          {track.map((src, index) => <div key={index} className="relative flex-shrink-0 h-56 sm:h-64 md:h-80 aspect-[9/16] rounded-2xl overflow-hidden shadow-soft border border-cream-dark" data-id="element-204">
              <img src={src} alt="Lector con el libro Este libro es más barato que la terapia" className="w-full h-full object-cover" loading="lazy" data-id="element-205" />
            </div>)}
        </motion.div>
      </div>
    </section>;
}